import { reducerWrapper } from '../support/utils';
import { GET_QUICK_LINK_TEMPLATES } from '../actions/QuickLinkTemplateActions';

export interface QuickLinkTemplateModelData {
  id: string;
  appId: string;
  name: string;
  note?: string;
  template: any;
  created: Date;
  createdBy: string;
  deleted: boolean;
}

export type QuickLinkTemplateModel = { data: QuickLinkTemplateModelData[]; total: number; pagesize: number };

export type QuickLinkTemplateReducer = {
  loadingStatus: number;
  loading: boolean;
  error: any;
  quickLinkTemplates: QuickLinkTemplateModel;
};

const INIT_STATE: QuickLinkTemplateReducer = {
  loadingStatus: 0,
  loading: true,
  error: null,
  quickLinkTemplates: { data: [], pagesize: 0, total: 0 },
};

function Handler(state, action) {
  switch (action.type) {
    case GET_QUICK_LINK_TEMPLATES.response:
      return {
        ...state,
        loadingStatus: 2,
        quickLinkTemplates: action.data,
        loading: false,
      };
    default:
      return state;
  }
}

const QuickLinkTemplate = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_QUICK_LINK_TEMPLATES],
  error: [GET_QUICK_LINK_TEMPLATES],
  resetOn: ['APP_CHANGE'],
});

export default QuickLinkTemplate;
